import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=88ebeca8"
import script from "./withdraw.vue?vue&type=script&lang=ts"
export * from "./withdraw.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports